<template>
  <el-dialog
    :visible="value"
    title="切换环境"
    width="600"
    @close="handleCancel"
  >
    <div style="line-height: 40px">ERP请求域名：</div>
    <el-row>
      <el-col :span="3">
        <el-button type="text">{{
          protocolMap[requestConfig.erpSuffix]
        }}</el-button>
      </el-col>
      <el-col :span="21">
        <el-input
          v-model="requestConfig.erpEnv"
          placeholder="需求编号或数字"
          clearable
        >
          <template #prepend>
            <el-select v-model="requestConfig.erpHost" style="width: 150px">
              <el-option value="erp-feat-">erp-feat-</el-option>
              <el-option value="erp-stable">erp-stable</el-option>
            </el-select>
          </template>
          <template #append>
            <el-select
              v-model="requestConfig.erpSuffix"
              disabled
              style="width: 180px"
            >
              <el-option
                v-for="item in SUFFIX_OPTIONS"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </el-option>
            </el-select>
          </template>
        </el-input>
      </el-col>
    </el-row>
    <div style="line-height: 40px">OS请求域名：</div>
    <el-row>
      <el-col :span="3">
        <el-button type="text">{{
          protocolMap[requestConfig.osSuffix]
        }}</el-button>
      </el-col>
      <el-col :span="21">
        <el-input
          v-model="requestConfig.osEnv"
          placeholder="需求编号或数字"
          clearable
        >
          <template #prepend>
            <el-select v-model="requestConfig.osHost" style="width: 150px">
              <el-option value="os-feat-">os-feat-</el-option>
              <el-option value="os-stable">os-stable</el-option>
            </el-select>
          </template>
          <template #append>
            <el-select
              v-model="requestConfig.osSuffix"
              disabled
              style="width: 180px"
            >
              <el-option
                v-for="item in SUFFIX_OPTIONS"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </el-option>
            </el-select>
          </template>
        </el-input>
      </el-col>
    </el-row>
    <div style="line-height: 40px">微服务请求域名：</div>
    <el-row>
      <el-col :span="3">
        <el-button type="text">{{
          protocolMap[requestConfig.gatewaySuffix]
        }}</el-button>
      </el-col>
      <el-col :span="21">
        <el-input
          v-model="requestConfig.gatewayEnv"
          placeholder="需求编号或数字"
          clearable
        >
          <template #prepend>
            <el-select v-model="requestConfig.gatewayHost" style="width: 150px">
              <el-option value="gateway-dev">gateway-dev</el-option>
              <el-option value="gateway-pre">gateway-pre(预发布)</el-option>
            </el-select>
          </template>
          <template #append>
            <el-select
              v-model="requestConfig.gatewaySuffix"
              style="width: 180px"
              disabled
            >
              <el-option
                v-for="item in SUFFIX_OPTIONS"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </el-option>
            </el-select>
          </template>
        </el-input>
      </el-col>
    </el-row>
    <div style="line-height: 40px">API请求域名：</div>
    <el-row>
      <el-col :span="3">
        <el-button type="text">{{
          protocolMap[requestConfig.apiSuffix]
        }}</el-button>
      </el-col>
      <el-col :span="21">
        <el-input
          v-model="requestConfig.apiEnv"
          placeholder="需求编号或数字"
          clearable
        >
          <template #prepend>
            <el-select v-model="requestConfig.apiHost" style="width: 150px">
              <el-option value="api-feat-">api-feat-</el-option>
              <el-option value="api-stable">api-stable</el-option>
            </el-select>
          </template>
          <template #append>
            <el-select
              v-model="requestConfig.apiSuffix"
              disabled
              style="width: 180px"
            >
              <el-option
                v-for="item in SUFFIX_OPTIONS"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </el-option>
            </el-select>
          </template>
        </el-input>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <div style="line-height: 40px">跳转到OS后台域名：</div>
    <el-row>
      <el-col :span="3">
        <el-button type="text">{{
          protocolMap[requestConfig.oswebSuffix]
        }}</el-button>
      </el-col>
      <el-col :span="21">
        <el-input
          v-model="requestConfig.oswebEnv"
          placeholder="需求编号或数字"
          clearable
        >
          <template #prepend>
            <el-select v-model="requestConfig.oswebHost" style="width: 150px">
              <el-option value="osweb-feat-">osweb-feat-</el-option>
              <el-option value="osweb-stable">osweb-stable</el-option>
            </el-select>
          </template>
          <template #append>
            <el-select
              v-model="requestConfig.oswebSuffix"
              disabled
              style="width: 180px"
            >
              <el-option
                v-for="item in SUFFIX_OPTIONS"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </el-option>
            </el-select>
          </template>
        </el-input>
      </el-col>
    </el-row>
    <template #footer>
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSave">确定</el-button>
    </template>
  </el-dialog>
</template>
<script>
import STORAGE_KEY from "@/const/storage.js";
import { defaultProdRequestConfig, defaultRequestConfig } from "@/const/env.js";

const SUFFIX_OPTIONS = [
  {
    label: ".yishou.com",
    value: ".yishou.com",
  },
  {
    label: ".yishouapp.com",
    value: ".yishouapp.com",
  },
];
// 域名协议
const protocolMap = {
  ".yishou.com": "http://",
  ".yishouapp.com": "https://",
};
export default {
  name: "EnvModal",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      protocolMap,
      SUFFIX_OPTIONS,
      requestConfig: {
        ...(process.env.NODE_ENV === "test" ||
        process.env.NODE_ENV === "development"
          ? defaultRequestConfig
          : defaultProdRequestConfig),
      },
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          const requestConfig =
            localStorage.getItem(STORAGE_KEY.requestConfig) || "{}";
          this.requestConfig = {
            ...this.requestConfig,
            ...JSON.parse(requestConfig),
          };
        }
      },
    },
  },
  methods: {
    handleCancel() {
      this.$emit("input", false);
    },
    handleSave() {
      this.$emit("input", false);
      localStorage.setItem(
        STORAGE_KEY.requestConfig,
        JSON.stringify(this.requestConfig)
      );
      window.location.reload();
    },
    handleVisibleChange(visible) {
      this.$emit("input", visible);
    },
    handleChangeGatewayEnv() {
      localStorage.setItem("gatewayEnv", this.gatewayEnv);
      window.location.reload();
      this.$emit("input", false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/EnvModal/index.vue